
import { createContext } from "react";
import { LoaderContextProps } from "../interfaces";


export const LoaderContext = createContext({} as LoaderContextProps)